<template>
  <section class="section">
    <div class="tlCnt">
      <div class="tlItem" :class="{active: st === 1}">1</div>
      <div class="tlItem" :class="{active: st === 2}">2</div>
      <div class="tlItem" :class="{active: st === 3}">3</div>
      <div class="tlItem" :class="{active: st === 4}">4</div>
      <div class="tlItem" :class="{active: st === 5}">5</div>
    </div>
    <div class="pageLoading" v-if="loading"></div>
    <div class="formCnt" v-else>
      <div class="welcomeCnt">
        <div class="welcome">
          Reset password <h4>{{name}}</h4>
        </div>
      </div>

      <div class="formInfo">Masukan password baru</div>
      <form v-on:submit.prevent="handleSubmit" v-if="st === 1">
        <div :class="{fieldGroup: true, hasError: form.password.error}">
          <div class="fieldCnt">
            <input :type="form.password.type" class="field" placeholder="Password"
              v-model="form.password.model" v-on:input="fieldChanged('password')">
            <div :class="{showPwd: true, show: form.password.type === 'text'}"
              v-on:click="form.password.type = (form.password.type === 'text')
              ? 'password' : 'text'"></div>
          </div>
          <div class="fieldError" v-if="form.password.error">{{form.password.error}}</div>
        </div>
        <div :class="{fieldGroup: true, hasError: form.password2.error}">
          <div class="fieldCnt">
            <input :type="form.password2.type" class="field" placeholder="Ulangi Password"
              v-model="form.password2.model" v-on:input="fieldChanged('password2')">
            <div :class="{showPwd: true, show: form.password2.type === 'text'}"
              v-on:click="form.password2.type = (form.password2.type === 'text')
              ? 'password' : 'text'"></div>
          </div>
          <div class="fieldError" v-if="form.password2.error">{{form.password2.error}}</div>
        </div>
        <button class="btn primary block" :class="{btnLoading: formLoading}">
          <span>Reset Password</span></button>
      </form>
    </div>
    <PwdChanged ref="pwdChanged"/>
  </section>
</template>

<script>
import PwdChanged from '@/components/PwdChanged.vue';

export default {
  name: 'home',
  components: { PwdChanged },
  data() {
    return {
      st: 1,
      name: null,
      loading: true,
      formLoading: false,
      token: null,
      form: {
        password: { model: '', error: null, type: 'password' },
        password2: { model: '', error: null, type: 'password' },
      },
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    doNothing() {},
    selectChar(char) {
      this.selectedChar = char;
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
    handleSubmit() {
      if (this.formLoading) return;
      const formData = {
        token: this.token,
        password: this.form.password.model,
      };
      if (!formData.password || formData.password === ''
        || formData.password.length < 8) {
        this.form.password.error = 'Password minimal 8 karakter.';
        return;
      }
      if (formData.password !== this.form.password2.model) {
        this.form.password2.error = 'Password tidak sama.';
        return;
      }
      this.formLoading = true;
      this.$http.post(this.$config.uri('user/change/pwd'), formData).then((r) => {
        this.formLoading = false;
        if (r.data.status !== 200) {
          const msg = (r.data.message) ? r.data.message : 'Internal server error, please try again later';
          this.form.password.error = msg;
          return;
        }
        this.$refs.pwdChanged.open(null, () => {
          this.$router.push('/login');
        });
      });
    },
  },
  mounted() {
    this.token = this.$route.query.token;
    if (!this.token || this.token === '') {
      this.$router.push('/');
    }
    this.$http.post(this.$config.uri('user/forgot/verify'), {
      token: this.token,
    }).then((r) => {
      if (r.data.status === 200) {
        this.loading = false;
        this.name = r.data.name;
        return;
      }
      this.$router.push('/');
    });
  },
};
</script>

<style scoped lang="scss">
.welcomeCnt{
  // text-align: center;
  .welcome{
    background-color: #e9ffcc;
    // display: inline-block;
    border-radius: 5px;
    padding: 10px 15px;
    font-size: 14px;
    text-align: left;
    // margin: 20px 0 12px;
    border: #78c90e 1px solid;
    position: relative;
    color: #767676;
    h4{
      margin: 0px 0 0;
      font-size: 17px;
      color: #417201;
    }
    .close{
      position: absolute;
      right: 10px; top: 50%;
      background-color: #78C90E;
      border-radius: 50px;
      padding: 5px 12px;
      color: #fff;
      font-weight: 600;
      margin-top: -14px;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #5ba100;
      }
    }
  }
}
.formInfo{
  margin: 34px 10px 10px;
  font-weight: 600;
  font-size: 14px;
  color: #555;
  &.syaratnya{
    margin: 16px 10px 10px;
  }
  // text-transform: uppercase;
}
.formCnt{
  width: 100%;
}
.section{
  padding: 40px 20px;
  display: flex;
  align-items: center;
  min-height: 100vh;
  box-sizing: border-box;
}
.pageLoading{
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  background-image: url(../assets/loading.svg);
  background-size: 54px auto;
  background-position: center;
  background-repeat: no-repeat;
}
.tlCnt{
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin: 40px 0 26px;
  display: none;
  &:before{
    content: "";
    position: absolute;
    top: 14px; left: 10px; right: 10px;
    height: 6px; background-color: #faeba9;
    border: #cddd00 2px solid;
  }
  .tlItem{
    width: 36px;
    height: 36px;
    text-align: center;
    font-weight: bold;
    box-sizing: border-box;
    font-size: 24px;
    padding-top: 3px;
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(../assets/circle-bg-inactive.png);
    color: #767676;
    z-index: 3;
    &.active{
      background-image: url(../assets/circle-bg.png);
      color: #fff;
    }
  }
}
.aboCnt{
  margin-bottom: 20px;
  // box-shadow: 2px 2px 4px rgba(0,0,0,.1);
  box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
  padding: 10px 16px;
  font-size: 14px;
  color: #767676;
  border-radius: 7px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, .5);
  // background-color: #f1eeca;
  span{
    display: block;
    font-size: 20px;
    border-radius: 3px;
    font-weight: bold;
    color: #444;
  }
}
.fieldGroup.divider{
  height: 2px;
}
.charCnt{
  display: flex;
  justify-content: space-between;
  margin: 80px 0 0;
  .charItem{
    text-align: center;
    width: calc(50% - 10px);
    .theChar{
      height: 200px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      &.nunu{
        background-image: url(../assets/nunu-hi.png);
      }
      &.lili{
        background-image: url(../assets/lili-hi.png);
        height: 140px;
        margin: 36px 0 24px;
      }
    }
    h4{
      margin: 0;
      font-size: 18px;
    }
    p{
      margin: 0;
      font-size: 14px;
    }
  }
  &.selected{
    margin: 20px 0 20px;
    display: block;
    .charItem{
      width: auto;
      .theChar{
        margin-bottom: 20px;
        height: 280px;
        &.nunu{
          background-image: url(../assets/nunu-iddle.png);
        }
      }
      h4{
        font-size: 24px;
      }
      p{
        font-size: 16px;
      }
    }
  }
}
.ckCnt{
  padding-left: 34px;
  position: relative;
  display: block;
  font-size: 15px;
  font-weight: normal;
  text-transform: none;
  color: #444;
  .fieldError{
    margin: 4px 0 0;
  }
}
.checkbox{
  width: 16px; height: 16px;
  border: #999 2px solid;
  border-radius: 3px;
  position: absolute;
  left: 2px; top: 2px;
  &.checked{
    background-color: #78C90E;
    border-color: #78C90E;
    background-image: url(../assets/checked.png);
    background-size: 16px auto;
    background-position: center;
    background-repeat: no-repeat;
  }
  &.hasError{
    border-color: red;
  }
}
.charPreview{
  width: auto;
  height: 280px;
  background-image: url(../assets/nunu-iddle.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin: 30px auto;
}
.accCnt{
  margin: 0 0 26px;
  h5{
    margin: 0 7px 6px;
    text-align: left;
    font-size: 16px;
    color: #555;
  }
  .theAcc{
    display: flex;
    .accItem{
      width: 60px;
      height: 60px;
      background-color: #addc91;
      margin-right: 10px;
      border-radius: 12px;
      box-sizing: border-box;
      &.disabled{
        background-color: #ccc;
        color: #767676;
        font-size: 11px;
        padding-top: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
    }
  }
}
.formHeader{
  text-align: center;
  .nunuLili{
    text-align: center;
    &.mantul{
      margin-bottom: 40px;
    }
    img{
      height: 260px;
    }
  }
  h4{
    color: #006519;
    font-weight: bold;
    font-size: 26px;
    margin: 0 0 10px;
  }
  p{
    font-size: 16px;
    margin-top: 0;
    b.cyl{
      display: inline-block;
      margin-top: 6px;
      color: #006519;
      font-size: 22px;
    }
  }
}
.loginLinkCnt{
  text-align: center;
}
.loginLink{
  font-size: 15px;
  padding: 6px 10px;
  display: inline-block;
  margin: 12px auto 0;
}
</style>
